<template>
  <div class="mall-specil-item">
    <!-- 商城目前最多可配置两层规格 -->
    <template v-if="upSpecilList.length">
      <!-- 上规格 -->
      <Specile
        v-model="upSpecilId"
        :label="goods.upSpecilName"
        :specilList="upSpecilList"
        @onChange="getDownSpecilList"/>

      <!-- 下规格 -->
      <Specile
        v-if="hasDownSpecil"
        v-model="downSpecilId"
        :label="goods.downSpecilName"
        :specilList="downSpecilList"
        @onChange="onDownChange"/>
    </template>

    <!-- 无库存提示 -->
    <div v-else class="mall-specil-list--no">
      该课程已售罄，暂时无法购买
    </div>
  </div>
</template>

<script>
import Specile from './specilOptions.vue';

export default {
  name: 'MallSpecilPanel',
  components: {
    Specile
  },
  props: {
    goods: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      upSpecilId: '',
      downSpecilId: '',
      upSpecilList: [],
      downSpecilList: [],
      specilMapping: [],
      records: {}
    };
  },
  computed: {
    hasDownSpecil() {
      return this.goods.downSpecilName;
    },
    specileKey() {
      if (this.goods.downSpecilName) {
        return `${this.upSpecilId}-${this.downSpecilId}-`;
      }
      return  `${this.upSpecilId}-`;
    },
    skuId() {
      const result = this.goods.specilMapping.find(item => item.key === this.specileKey);
      return result ? result.skuId : '';
    },
    hasStock() {
      return this.upSpecilList.length ? true : false;
    }
  },
  watch: {
    specileKey() {
      this.onSpecilIdChange();
    }
  },
  created() {
    this.initData();
    this.getDownSpecilList();
  },
  methods: {
    // 初始选中的规格、化库存提示、合并真假库存字断, stockNum：真库存、零库存， fakeStockNum：假库存
    initData() {
      const { upSpecil, upSpecilId, downSpecilId, stockReminderNum, stockReminderContent, specilMapping } = this.goods;
      // 1、初始化低库存提示、库存数量
      specilMapping.forEach(item => {
        // 将假库存数量兑换到真实库存字断，方便后面的库存展示
        item.fakeStockValid === 1 && (item.stockNum = item.fakeStockNum);

        // 设置低库存提示
        if (stockReminderContent) {
          item.stockReminderContent = stockReminderContent.replace('%s', item.stockNum);
        }
        // 如果库存低于设置值，展示库存提示
        if (stockReminderNum > item.stockNum) {
          item.isShowStockReminderContent = true;
        }
      });
      this.specilMapping = specilMapping;

      // 2、过滤上规格零库存
      this.upSpecilList = upSpecil.filter(item => {
        return this.specilMapping.find(sp => sp.key.includes(item.specilId) && sp.stockNum > 0);
      });

      // 3、设置选中的规格
      this.upSpecilId = upSpecilId;
      downSpecilId && this.onDownChange({ data: { specilId: downSpecilId } });
      if (!this.upSpecilId && this.upSpecilList.length) {
        this.upSpecilId = this.upSpecilList[0].specilId;
      }
      // 后台关闭了默认规格自动选中，故规格就不能选中
      if (this.goods.skuSwitch != 1) {
        this.upSpecilId = '';
      }

      this.$emit('load', { hasStock: this.hasStock, goodsId: this.goods.goodsId });

      if (this.hasDownSpecil || !this.upSpecilList.length) {
        return;
      }

      // 没有下规格时，设置上规格的stockReminderContent、isShowStockReminderContent
      this.goods.upSpecil.forEach(element => {
        const r = this.specilMapping.find(item => item.key === `${element.specilId}-`);
        if (r) {
          element.stockReminderContent = r.stockReminderContent;
          element.isShowStockReminderContent = r.isShowStockReminderContent;
        }
      });
    },
    // 筛选下规格数据
    getDownSpecilList() {
      const downSpecilList = [];
      const specilMapping = [];
      if (this.goods.downSpecil) {
        // 根据上规格id筛选对应的有库存的下规格id
        this.goods.downSpecil.forEach(element => {
          const r = this.specilMapping.find(item => item.key === `${this.upSpecilId}-${element.specilId}-`);
          if (r && r.stockNum > 0) {
            element.stockReminderContent = r.stockReminderContent;
            element.isShowStockReminderContent = r.isShowStockReminderContent;
            downSpecilList.push(element);
            specilMapping.push(r);
          }
        });
      }
      this.downSpecilList = downSpecilList;
      // 切换上规格时，如果存在历史记录，默认展示历史记录中的下规格
      if (this.records[this.upSpecilId]) {
        this.downSpecilId = this.records[this.upSpecilId];
        return;
      }
      if (downSpecilList.length) {
        // 筛选出库存最多的下规格id
        const sortResult = specilMapping.sort((a, b) => b.stockNum - a.stockNum);
        this.downSpecilId = this.goods.skuSwitch ? sortResult[0].key.split('-')[1] : '';
      } else {
        this.downSpecilId = '';
      }
    },
    // 下规格发生变化时，缓存选中的规格
    onDownChange({ data }) {
      this.records[this.upSpecilId] = data.specilId;
    },
    // 规格选项发生变化，将新值传递给父组件
    onSpecilIdChange() {
      this.$emit('onChange', {
        upSpecilId: this.upSpecilId,
        downSpecilId: this.downSpecilId,
        goodsId: this.goods.goodsId ? this.goods.goodsId : this.goods.id,
        skuId: this.skuId,
        hasStock: this.hasStock
      });
      this.$set(this.goods, 'skuId', this.skuId);
      this.$set(this.goods, 'upSpecilId', this.upSpecilId);
      this.$set(this.goods, 'downSpecilId', this.downSpecilId);
      this.$set(this.goods, 'downSpecilId', this.downSpecilId);
      this.$set(this.goods, 'hasStock', this.hasStock);
    },
    // 重置数据
  }
};
</script>

<style lang="stylus" scoped>
.mall-specil-item {
  margin: 14px 0 8px;
}
.mall-specil-label {
  height: 0.46rem;
  line-height: 0.46rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: bold;
  color: #6D6D80;
}
.mall-specil-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mall-specil-list--no {
  margin: 30px 0 40px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #A1A1B3;
}
</style>